"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _MEDIA_QUERIES$small,
    _cxs,
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs2 = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    LAST_DATE_PICKER_SELECTOR = " > .date-picker:last-of-type:not(:only-of-type)",
    LAST_LABEL_SELECTOR = " > label:last-of-type:not(:only-of-type)",
    MOBILE_MARGIN = {
  marginLeft: "0",
  marginTop: "15px"
},
    _default = (0, _cxs2["default"])((_cxs = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  " > .date-picker": {
    width: "100%"
  }
}, (0, _defineProperty2["default"])(_cxs, LAST_DATE_PICKER_SELECTOR, {
  marginLeft: "15px"
}), (0, _defineProperty2["default"])(_cxs, LAST_LABEL_SELECTOR, {
  marginLeft: "15px"
}), (0, _defineProperty2["default"])(_cxs, _vars.MEDIA_QUERIES.small, (_MEDIA_QUERIES$small = {
  flexDirection: "column"
}, (0, _defineProperty2["default"])(_MEDIA_QUERIES$small, LAST_DATE_PICKER_SELECTOR, MOBILE_MARGIN), (0, _defineProperty2["default"])(_MEDIA_QUERIES$small, LAST_LABEL_SELECTOR, MOBILE_MARGIN), _MEDIA_QUERIES$small)), _cxs));

exports["default"] = _default;